import styled from "styled-components";

export const VideoCoverWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #0043ff;
  background-image: url(${(props) => props.bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 200px 120px;
  min-height: 570px;
  div {
    display: flex;
  }
  @media (max-width: 768px) {
    padding: 0;
    min-height: 360px;
    .fixed-container {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  }
`;

export const VideoTitle = styled.div`
  color: #ffffff;
  font-size: 3.75rem;
  font-weight: bold;
  max-width: 70%;
  line-height: 4.5rem;
  @media (max-width: 768px) {
    font-size: 1.6rem;
    line-height: 2rem;
  }
`;

export const PlayBtn = styled.a`
  display: block;
  margin: auto;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  transition: transform 0.35s cubic-bezier(0.2, 0.7, 0.2, 1), box-shadow 0.35s ease;
  img {
    display: block;
  }
  &:hover {
    transform: scale(1.08);
    box-shadow: 0 0 0 14px rgba(250, 251, 255, 0.18);
  }
  &:active {
    transform: scale(0.97);
  }
  &:focus-visible {
    outline: 3px solid #02c5ff;
    outline-offset: 6px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 20px;
    img {
      width: 50px;
    }
  }
`;
